import React, { useState, useEffect } from "react";
import { formatDate } from "../common/dateFormatter";


const RegistrationForm = ({
  onSubmit,
  initialValues = {},
  setBillingEmail,
  billingEmail,
  seats,
  seatIndex,
  setActiveIndex,
  howDidYouHear,
  isFirstAttendee,
  hideSubmitButton = false
}) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",
    billingEmail: "",
    phone: "",
    termsConditions: false,
    codeOfConduct: false,
    useInfoForAll: false,
    isEnrolled: false,
    isBillingEmail: false,
    ...initialValues,
  });

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      ...initialValues,
    }));
  }, [initialValues]);

  // useEffect(() => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     ...initialValues,
  //     isBillingEmail: billingEmail === initialValues.email,
  //   }));
  // }, [initialValues, billingEmail]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "isBillingEmail" && checked) {
      setBillingEmail(formData.email);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

  };

const handleSubmit = (e) => {
    e.preventDefault();

    // Validate "How did you hear about us" for first attendee
    if (isFirstAttendee && !howDidYouHear) {
      alert("Please select how you heard about us");
      return;
    }

    onSubmit(formData);

    if (seatIndex + 1 < seats && setActiveIndex) {
      setActiveIndex(seatIndex + 1);
    }

    // Clear form for next attendee only if not hiding submit button
    if (!hideSubmitButton) {
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        confirmEmail: "",
        phone: "",
        agreeToTerms: false,
      });
    }
  };

  // Auto-save data when form changes (for the new all-at-once view)
  useEffect(() => {
    if (hideSubmitButton && Object.keys(formData).some(key => formData[key] !== initialValues[key])) {
      const timeoutId = setTimeout(() => {
        onSubmit(formData);
      }, 500); // Auto-save after 500ms of no changes
      
      return () => clearTimeout(timeoutId);
    }
  }, [formData, hideSubmitButton, onSubmit, initialValues]);


  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <label htmlFor="firstName" className="block text-sm font-semibold text-gray-700 mb-2">
            First Name *
          </label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
            className="w-full h-12 px-4 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
            placeholder="Enter first name"
          />
        </div>
<div>
          <label htmlFor="lastName" className="block text-sm font-semibold text-gray-700 mb-2">
            Last Name *
          </label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
            className="w-full h-12 px-4 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
            placeholder="Enter last name"
          />
        </div>
      </div>

      <div>
        <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
          Email Address *
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          className="w-full h-12 px-4 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
          placeholder="Enter email address"
        />
      </div>

      <div>
        <label htmlFor="confirmEmail" className="block text-sm font-semibold text-gray-700 mb-2">
          Confirm Email Address *
        </label>
        <input
          type="email"
          id="confirmEmail"
          name="confirmEmail"
          value={formData.confirmEmail}
          onChange={handleChange}
          required
          className="w-full h-12 px-4 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
          placeholder="Confirm email address"
        />
      </div>

      <div>
        <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
          Phone Number *
        </label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
          className="w-full h-12 px-4 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
          placeholder="Enter phone number"
        />
      </div>
<div className="bg-gray-50 rounded-xl p-4">
        <label className="flex items-start space-x-3">
          <input
            type="checkbox"
            name="agreeToTerms"
            checked={formData.agreeToTerms}
            onChange={handleChange}
            required
            className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 mt-1"
          />
          <span className="text-sm text-gray-700 leading-relaxed">
            I agree to the{" "}
            <a 
              href="/classroom-code-of-conduct" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-blue-600 underline hover:text-blue-700"
            >
              Code of Conduct
            </a>{" "}
            and understand the terms and conditions for this training program. *
          </span>
        </label>
      </div>

      {!hideSubmitButton && (
        <button
          type="submit"
          className="w-full h-14 bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700 text-white font-bold text-lg rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-[1.02] flex items-center justify-center space-x-2"
        >
          <span>{seatIndex + 1 === seats ? "Complete Registration" : "Save & Continue"}</span>
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      )}
    </form>
  );
};

export default RegistrationForm;